const resetPlatformScroll = () => {
  const pageScroll = document.querySelector<HTMLElement>('.layout__platform-content');

  pageScroll?.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  if (pageScroll) {
    pageScroll.scrollTop = 0;
    pageScroll.scrollLeft = 0;
  }

  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  window.dispatchEvent(new Event('resize'));
};

export const restorePlatformScrollAfterTour = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;

  document.documentElement.classList.remove('driver-active');
  document.body.classList.remove('driver-active');

  const platformRoot = document.querySelector<HTMLElement>('.layout__root--platform.ant-layout');
  platformRoot?.classList.add('layout__root--tour-reflow');
  if (platformRoot) void platformRoot.offsetHeight;

  window.requestAnimationFrame(() => {
    platformRoot?.classList.remove('layout__root--tour-reflow');
    if (platformRoot) void platformRoot.offsetHeight;
    resetPlatformScroll();
    window.requestAnimationFrame(resetPlatformScroll);
    window.setTimeout(resetPlatformScroll, 80);
    window.setTimeout(resetPlatformScroll, 240);
  });
};
